import react, { useState, useEffect, useRef } from "react";
import officesittingImg from '../careers/careersImage/unnamed.webp'
import ThinkwikBenefits from "./thinkwikBenefits";
import JobSection from "./JobSection";
import FilteredImages from "./filteredImages ";
import HeadquarterSection from "./HeadquarterSection";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from "react-helmet";
import CareerForm from "./careerForm";

const Careers = () => {
  const [selectedRole, setSelectedRole] = useState('');
  const formRef = useRef(null);

  const scrollToForm = () => {
    if (formRef.current) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // Function to be called when Apply Now is clicked
  const handleApplyClick = (role) => {
    setSelectedRole(role);
    // Scroll to form after slight delay (to allow state update/render)
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 200);
  };
  return (
    <>
      <Helmet>
        <title>Career Opportunities | Join Our Team & Grow with Us</title>
        <meta name="description" content="Explore exciting career opportunities with us. Join a dynamic team, grow your skills, and contribute to innovative projects. Your future starts here!" />
        <meta name="keywords" content="Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services" />
      </Helmet>
      <div className="max-w-8xl mx-10 lg:mx-auto lg:w-[84%] xl:w-[80%] xxl:w-[80%]  px-4 py-6 font-recoleta">

        <div className="mt-44">
          <h2 data-aos="fade-up" className="2xl:text-[40px] text-[#09588D] lg:text-[32px] text-[84px] font-recoleta font-bold">
            Your Next Career Move Starts Here
          </h2>
          <p className="2xl:text-[26px] lg:text-[20px] text-[34px]  mt-6 font-recoleta" data-aos="fade-up">Are you brilliant, persistent, and creative? Assuming this is the case, TekIT Software Solution might be the ideal spot for you to develop your profession! Does this sound like you? Go along with us!</p>
          <p className="2xl:text-[26px] lg:text-[20px] text-[34px]  mt-6 font-recoleta" data-aos="fade-up">We convey quality through profound specialization and development and employ individuals who share our values, keep up solid connections, and carry thoughts to the table.</p>
        </div>
        <div className="py-20 mt-4">
          <img src={officesittingImg} data-aos="fade-up" alt="" className="w-full h-full" />
        </div>
      </div>
      <ThinkwikBenefits />
      <JobSection setSelectedRole={setSelectedRole} scrollToForm={scrollToForm} />
      <HeadquarterSection />
      <div ref={formRef}>
        <CareerForm selectedRole={selectedRole} />
      </div>
    </>
  )
}
export default Careers;